module.exports = __webpack_public_path__ + "static/media/thumb-down-solid.137e6f4e.svg";